import { useQuery } from '@tanstack/react-query'
import { apiFetch } from '@shared/api/http'
import { useSession } from '@shared/lib/auth/session-store'
import { ReferralProgramSchema, ReferralSummarySchema } from './referral.contract'
import { z } from 'zod'
import { useFeatureFlag } from '@shared/feature-flags/useFeatureFlag'

export const referralReceivingNotice =
  'Você pode indicar e acumular comissões antes da aprovação cadastral. O repasse aguarda sua conta estar apta a receber e a conclusão do processamento.'

export function useReferralAccess() {
  const enabled = useFeatureFlag('referralProgram')
  const userId = useSession((state) => state.user?.id)
  return useQuery({
    queryKey: ['referrals', userId, 'access'],
    enabled: enabled && !!userId,
    queryFn: async () =>
      z
        .object({ enabled: z.boolean(), dashboardEnabled: z.boolean().default(false) })
        .parse(await apiFetch('/referrals/access')),
    staleTime: 30000,
    refetchOnWindowFocus: 'always',
  })
}

export function useReferralSummary(enabled: boolean) {
  const userId = useSession((state) => state.user?.id)
  return useQuery({
    queryKey: ['referrals', userId, 'summary'],
    enabled: enabled && !!userId,
    queryFn: async () => ReferralSummarySchema.parse(await apiFetch('/referrals/summary')),
    staleTime: 30000,
    refetchOnWindowFocus: 'always',
  })
}

export function useReferrals(offset: number, enabled: boolean) {
  const userId = useSession((state) => state.user?.id)
  return useQuery({
    queryKey: ['referrals', userId, offset],
    enabled: enabled && !!userId,
    queryFn: async () =>
      ReferralProgramSchema.parse(await apiFetch(`/referrals?limit=20&offset=${offset}`)),
    staleTime: 30000,
  })
}
